import * as React from "react";
import PageHeader from '../../common/pageheader/PageHeader';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import {
    MessageBar,
    MessageBarType,
    Link
} from '@fluentui/react';


export const DeraHistoryReport: React.FC = () => {

    return (
        <div>
            <PageHeader
                title="Dera History"
                description="This report shows the historical information for stamps"
            />
            <div>
                <BodyPage />
            </div>
        </div>

    )
}

const BodyPage: React.FC = () => {
    return (
        <div>
            <MessageBar>
                Please go to
                <Link href="https://aka.ms/tesseract/m2cp/dera" inline>
                    aka.ms/tesseract/m2cp/dera
                </Link>{' '}
                to check original report
            </MessageBar>
            <iframe title="M365 BackEnd Lead Time"
                style={{ width: "100%", height: "1050px", marginTop: '20px' }}
                src="https://aka.ms/tesseract/m2cp/dera-embeded"
                frameBorder={0}
                allowFullScreen={true}></iframe>
        </div>
    );
}